// Aurelia shop/category pages — hover-reveal product videos.
// PAIRS WITH: assets/shop.css (.shp-card markup) — ship together.
// Reveal videos ship with preload="none" and NO poster attribute; the
// poster comes from data-poster and is attached on first pointerenter,
// so touch devices never download the (invisible) reveal media at all.
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reduced motion: stop the decorative autoplay loops (bands, banner)
  if (reduce) {
    document.querySelectorAll('.shop video[autoplay]').forEach(function (v) {
      v.pause();
    });
  }

  var hoverable = window.matchMedia('(hover: hover)').matches;
  if (!hoverable) return; // touch: static render only

  document.querySelectorAll('.shp-card').forEach(function (card) {
    var video = card.querySelector('.shp-card__reveal video');
    if (!video) return;
    card.addEventListener('pointerenter', function () {
      if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      if (video.preload === 'none') video.preload = 'auto';
      if (reduce) return; // reveal shows the poster still, no motion
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
    card.addEventListener('pointerleave', function () {
      video.pause();
    });
  });
})();
